module.exports = __webpack_public_path__ + "img/changes.154a4008.svg";